import { render } from "./WorkMaskVsCode.vue?vue&type=template&id=919cd322&scoped=true"
import script from "./WorkMaskVsCode.vue?vue&type=script&lang=js"
export * from "./WorkMaskVsCode.vue?vue&type=script&lang=js"

import "./WorkMaskVsCode.vue?vue&type=style&index=0&id=919cd322&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-919cd322"]])

export default __exports__